const axios = require('axios');
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
axios.defaults.headers.common = {'Authorization': `Bearer ${process.env.REACT_APP_BEARER_TOKEN}`, 'Accept': 'application/json', 'Content-Type' : 'application/json'};
export default axios;